import { Point } from 'geojson'

/**
 * True when telemetry exposes a finite WGS84 lon/lat that is not (0,0).
 * Matches the same bounds used when updating the robot marker from odometry.
 */
export function hasValidNonZeroGeoPosition(point: Point | undefined): boolean {
  if (!point?.coordinates || point.coordinates.length < 2) return false
  const [lon, lat] = point.coordinates
  if (!isFinite(lon) || !isFinite(lat)) return false
  if (lon === 0 && lat === 0) return false
  if (lon < -180 || lon > 180 || lat < -90 || lat > 90) return false
  return true
}
